import { InteractiveContainer, Radio } from "@jugl-web/ui-kit";
import { cx } from "@jugl-web/utils";
import React from "react";

export interface ResponseModeOptionProps {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  description: React.ReactNode;
  isSelected: boolean;
  isDisabled?: boolean;
  onSelect: () => void;
}

export const ResponseModeOption: React.FC<ResponseModeOptionProps> = ({
  icon: Icon,
  title,
  description,
  isSelected,
  isDisabled,
  onSelect,
}) => (
  <InteractiveContainer
    onClick={onSelect}
    isDisabled={isDisabled}
    className={cx(
      "flex w-full max-w-[440px] flex-col gap-2.5 rounded-xl border border-solid bg-white p-4 pb-6 transition-colors max-lg:max-w-none max-lg:pb-4",
      isSelected ? "border-dark-700" : "border-grey-300 hover:bg-grey-100",
      isDisabled && "opacity-60"
    )}
  >
    <div className="flex items-center justify-between gap-2.5">
      <div className="flex items-center gap-2">
        <Icon className="h-[20px] w-[20px] shrink-0" />
        <span className="font-secondary text-[15px] leading-[150%] font-medium text-black">
          {title}
        </span>
      </div>
      <Radio size="md" isChecked={isSelected} readOnly />
    </div>
    <span className="font-secondary text-sm leading-[160%] text-dark-800">
      {description}
    </span>
  </InteractiveContainer>
);
